var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.slides.length
    ? _c(
        "div",
        [
          _c(
            "VueSlickCarousel",
            {
              staticClass: "slider",
              attrs: { arrows: false, dots: true, adaptiveHeight: false },
            },
            _vm._l(_vm.slides, function (slide) {
              return _c("div", { key: slide.id }, [
                _c("img", { attrs: { src: slide.path } }),
              ])
            }),
            0
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }